module.exports = __webpack_public_path__ + "static/img/ios1.4.dda31469.jpg";